import { hexToRgb } from '../../../../../utils/helpers/color-converter';
import { formatHour } from '../../common/tariff/utils';
import { DashboardPrice, EcoBoxIcon, EcoParams } from '../types/types';

export const ecoParamsByHeatmapColor: Record<string, EcoParams> = {
  '#00891C': {
    iconColor: '#00891C',
    text: 'use',
    icon: EcoBoxIcon.Leaf,
  },
  '#65A521': {
    iconColor: '#65A521',
    text: 'use',
    icon: EcoBoxIcon.Leaf,
  },
  '#93B224': {
    iconColor: '#93B224',
    text: 'use',
    icon: EcoBoxIcon.Leaf,
  },
  '#FFD028': {
    iconColor: '#FFD028',
    text: 'limit',
    icon: EcoBoxIcon.Face,
  },
  '#FFBA2E': {
    iconColor: '#FFBA2E',
    text: 'limit',
    icon: EcoBoxIcon.Face,
  },
  '#FF943A': {
    iconColor: '#FF943A',
    text: 'limit',
    icon: EcoBoxIcon.Face,
  },
  '#FF4D4D': {
    iconColor: '#FF4D4D',
    text: 'avoid',
    icon: EcoBoxIcon.Face,
  },
};

export const getFirstContinuousHours = (prices: DashboardPrice[], color?: string | null) => {
  if (!color) return null;

  const result: DashboardPrice[] = [];
  let collecting = false;

  for (const item of prices) {
    if (item.color === color) {
      result.push(item);
      collecting = true;
    } else if (collecting) {
      break;
    }
  }

  if (!result.length) return null;
  if (result.length === 1) return formatHour(result[0].startingHour);

  return `${formatHour(result[0].startingHour)} - ${formatHour(result[result.length - 1].startingHour)}`;
};

export const getEcoBoxBackgroundColor = (color: string) => `rgba(${hexToRgb(color)}, 0.4)`;
